module.exports = __webpack_public_path__ + "img/UP_semnatura.9478dfa2.jpg";